<template>
    <div class="page-wrapper v-cloak">
        <!-- CHUNKED JEWELLERY GRID VIEW WITH FEATURED JEWELRIES BETWEEN CHUNKS 1ST 2ND AND 3RD -->
        
        <div class="page-grid-wrapper">
            <div class="page-grid-fix"> 
                <h2>View our Jewellery</h2>
                <!-- FILTERS AND SEARCH -->
                <div class="search-and-filters">
                    <div class="fs-toggles">
                        <div @click="toggleSearch" class="search-toggle-btn search-icon">
                            <img v-if="searchedJewelries.length > 0" class="center" src="/images/icons/loupe-gold.svg">
                            <img v-else class="center" src="/images/icons/loupe-blk.svg">
                        </div>
                        <div @click="toggleFilters" class="filters-toggle-btn filter-icon">
                            <img v-if="filtersActive" class="center" src="/images/icons/filters-active.svg">
                            <img v-else class="center" src="/images/icons/filters-blk.svg">
                        </div>
                    </div>
                <!-- SEARCH -->
                    <div :class="['search-tray', { 'open': showSearch }]">

                        <SearchComponent 
                            :items="jewelries" 
                            :showSearch="showSearch"
                            @search-results="handleSearchResults"
                            @closeSearch="showSearch = false"
                        />
                        <a class="close-search" @click="toggleSearch">Close</a>
                        <!-- Search count tip -->
                        <div v-if="searchedJewelries.length" :class="['search-count', { alert: searchedJewelries.length === 0 }]">{{ searchedJewelries.length }} jewellery match{{ searchedJewelries.length === 1 ? 'es' : '' }} your criteria.</div>
                        <!-- <div v-else class="search-count ">Start typing desired jewellery details</div> --><!--Shown when no search activated yet or no results-->
                        
                        <div v-if="searchedJewelries.length > 0" class="list-grid-toggle view-icon" @click="toggleView">
                            <img v-if="gridView" class="center" src="/images/icons/list-view-icon.svg">
                            <img v-else class="center" src="/images/icons/grid-view-icon.svg">
                        </div>

                        <div class="search-results">

                            <div v-if="gridView" class="grid-view">
                                <span v-for="jewellery in searchedJewelries" :key="jewellery.SKU">
                                    <router-link :to="{ name: 'jewellerycard', params: { jewellerySKU: jewellery.SKU }}">
                                        <figure class="image-container">
                                            <img class="jewellery-image" :src="getImageGridSource(jewellery)" @error="() => loadAlternativeGridImage(jewellery)" alt="" :key="jewellery.SKU">
                                            <figcaption>
                                            <span>{{ jewellery.Model }}</span><br>
                                            <span>Available in {{ jewellery.JewelleryLocation }}</span>
                                            </figcaption>
                                        </figure>
                                    </router-link>
                                </span>
                            </div>

                            <ul v-else  class="list-view">
                                <li v-for="jewellery in searchedJewelries" :key="jewellery.SKU">
                                    <div class="search-list-container">
                                        <figure class="image-container">
                                            <img class="jewellery-image" :src="getImageGridSource(jewellery)" @error="() => loadAlternativeGridImage(jewellery)" alt="" :key="jewellery.SKU">
                                            <figcaption>
                                                <router-link :to="{ name: 'jewellerycard', params: { jewellerySKU: jewellery.SKU }}">

                                                    <h4>{{ jewellery.ManufacturerName }} {{ jewellery.Model }} </h4>
                                                </router-link>
                                                <p>Material: {{ jewellery.Material }}</p>
                                                <p>Year: {{ jewellery.Year }}</p>
                                                <p v-if="jewellery.StatusName === 'Sold'">Sold</p>
                                                <p v-if="jewellery.StatusName === null">In Stock</p>
                                                <p v-if="jewellery.StatusName === 'on hold'">In Stock</p>
                                                <p v-if="jewellery.StatusName === 'deposit'">On Deposit</p>
                                                <p v-else >{{ jewellery.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                    <span class="price" v-if="Number(jewellery.Price) > Number(siteSettings.poa_price_tag)">POA</span>
                                                    <span v-else class="price">
                                                        <span v-if="jewellery.Currency === '£'">£&nbsp; </span>
                                                        <span v-if="jewellery.Currency === 'CHF'">CHF&nbsp;</span>
                                                        <span v-if="jewellery.Currency === 'USD'">$&nbsp;</span>
                                                        <span v-if="jewellery.Currency === 'AED'">AED&nbsp;</span>
                                                        <span v-if="!jewellery.Currency">£&nbsp;</span>
                                                        {{ $formatNumber(jewellery.Price) }}
                                                        </span>
                                                    </p>
                                                <p class="appointment-at-location"><strong>Available</strong> for appointments at our <router-link  :to="{ path: '/locations', query: { location: jewellery.JewelleryLocation }}">
                                                    {{ jewellery.JewelleryLocation }}</router-link> boutique</p>
                                            </figcaption>
                                            <!-- Button to open the pop-up -->
                                            <button @click="openPopup(jewellery.SKU)">Enquire Now</button>
                                        </figure>
                                    </div>

                                    <!-- Popup Overlay -->
                                    <div v-if="activePopup === jewellery.SKU" class="popup-overlay" @click.self="closePopup">
                                        <div class="popup">
                                            <a class="close-btn" @click="closePopup">Close</a><br>
                                            <h4>Enquiry about {{ jewellery.ManufacturerName }} {{ jewellery.Model }} </h4>
                                            <EnquiryForm :Model="jewellery.Model" :SKU="jewellery.SKU" formOrigin="Jewellery - Search" />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        </div>     
    <!-- FILTERS -->
                    <div :class="['filters-tray', { 'open': showFilters }]">
                        <FiltersComponent 
                            ref="filtersComponent"
                            :filterOptions="dynamicFilters"
                            :resetFilters="resetFilters"
                            :filterCount="filteredJewelries.length"
                            @filters-active="handleFiltersActive"
                            @filter-changed="handleFilterChange"
                            @close-filters="toggleFilters" />
                        <!-- <div :class="['filtered-count', { alert: filteredJewelries.length === 0 }]">
                            <div style="text-align: center; width: 100%;" v-if="this.filtersActive && this.showFilters" :class="{ alert: filteredJewelries.length === 0 }">{{ filteredJewelries.length }} jewellery{{ filteredJewelries.length === 1 ? '' : 'es' }} match{{ filteredJewelries.length === 1 ? 'es' : '' }} your criteria.</div>
                            <div style="text-align: center; width: 100%;" v-else-if="this.showFilters" :class="{ alert: filteredJewelries.length === 0 }">{{ filteredJewelries.length }} jewelries available</div>
                        </div> -->
                    </div>
                    </div>

                <div v-if="this.filtersActive && !this.showFilters" class="filters-applied"> ACTIVE FILTERS 
                    <br><span>{{ displayAppliedFilters }}</span><br>
                    <span  v-if="this.filtersActive && !this.showFilters" class="buttons-inline">
                         <button @click="passResetFilters">Clear Filters</button> <button @click="toggleFilters" class="filters-toggle-btn filter-icon">Refine Filters</button>
                    </span>
                </div>
<!-- END of FILTERS AND SEARCH -->


<!-- GRID VIEW  -->
                <div  v-for="(jewelries, index) in allJewelries" :key="index">
                    <div class="jewelries">
                        <div class="grid-view array-chunk" v-if="filteredJewelries.length">
                            <div v-for="jewellery in  jewelries" :key="jewellery.SKU" class="grid-item jewellery__card" ref="card">
                                <div class="jewellery__card-content">

                                    <router-link :to="{ name: 'jewellerycard', params: { jewellerySKU: jewellery.SKU }}">
                                        <figure>
                                            <img class="jewellery-image" :src="getImageGridSource(jewellery)" @error="() => loadAlternativeGridImage(jewellery)" alt="" :key="jewellery.SKU">

                                            <figcaption>
                                                <p>{{ jewellery.Name }}</p>
                                            </figcaption>
                                            <figcaption>
                                                <span v-if="jewellery.StatusName === 'Sold'">Sold</span>
                                                <span v-if="jewellery.StatusName === null" class="status">In Stock</span>
                                                <span v-if="jewellery.StatusName === 'on hold'" class="status">In Stock</span>
                                                <span v-if="jewellery.StatusName === 'deposit'" class="status">On Deposit</span>
                                                <span v-else class="status">{{ jewellery.StatusName }}&nbsp;&nbsp;|&nbsp;
                                                    <span class="price" v-if="Number(jewellery.Price) > Number(siteSettings.poa_price_tag)">POA</span>
                                                    <span v-else class="price">
                                                        <span v-if="jewellery.Currency === '£'">£&nbsp; </span>
                                                        <span v-if="jewellery.Currency === 'CHF'">CHF&nbsp;</span>
                                                        <span v-if="jewellery.Currency === 'USD'">$&nbsp;</span>
                                                        <span v-if="jewellery.Currency === 'AED'">AED&nbsp;</span>
                                                        <span v-if="!jewellery.Currency">£&nbsp;</span>
                                                        {{ $formatNumber(jewellery.Price) }}
                                                        <br>
                                                        <span class="exc-taxes" v-if="jewellery.MarginScheme == '1'">&nbsp;exc.&ensp;taxes </span>
                                                    </span>
                                                </span>
                                                <div class="learn-more">   
                                                    View <img class="center" src="/images/icons/ArrowRight.svg">
                                                </div>
                                            </figcaption>
                                        </figure>
                                    </router-link>
                                </div>
                            </div>           
                        </div>
                    </div>
                    <!-- FEATURED JEWELLERY SELECTED IN FEATURED JEWELLERY TAB IN CMS -->
                    <div class="featured-jewellery" v-if="index == 0 || index == 1 || index == 2 || index == 3">
                        <FeaturedJewellery :loop="index" :route="showRoute" :sitePOA="siteSettings.poa_price_tag"></FeaturedJewellery>
                    </div>
                </div>
            </div>
        </div>		        
        <!-- END CHUNKED JEWELRIES GRID VIE WITH FEATURED JEWELRIES BETWEEN CHUNKS 1ST 2ND AND 3RD -->
        
        <!--NO SEARCH RESULT ALERT -->
        <div class="space-helper"></div>
        <div class="page-grid-wrapper">    
            <div class="page-grid-fix">
                <div v-if="!filteredJewelries.length && delayForm" class="no-search-results">
                    <h2>Unfortunately we can’t find what you are looking for right now</h2>
                    <p>Please Contact Us to Register Your Interest</p>
                    <form>
                        <ContactForm></ContactForm>                         
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import VuePagination from '../components/Pagination.vue';
import EnquiryForm from '../components/EnquiryForm.vue';
import FeaturedJewellery from '../components/FeaturedJewellery.vue';
import ContactForm from '../components//ContactForm.vue';
import FiltersComponent from '../components/FiltersComponent.vue';
import SearchComponent from '../components/SearchComponent.vue';

export default {
    name: 'JewelriesRandom',
    components: {
        VuePagination,
        EnquiryForm,
        FeaturedJewellery,
        ContactForm,
        FiltersComponent,
        SearchComponent
    },
    
    jewellery: {
            '$route.name': function () {
              this.showRoute = this.$route.name;
            },
          },
          
    props: ['siteSettings'],
    data() {
        return {
            window: {
                width: 0
            },
            windowWidth: window.innerWidth,
            // position: [],
            images: {},
            jewelries: [],   
            selectedBrand: 'Brand',  
            selectedStock: 'Availability', 
            selected: undefined,
            ShowInquiry: undefined,
            showRoute: {
                showRoute : this.$route.name
            },
            delayForm: false,
            isLoading: false,
            // search and filters
            activePopup: null,
            dynamicFilters: {}, // Object to store dynamic filter options
            filteredJewelries: [], // Array to store filtered jewelries
            searchedJewelries: [],
            showFilters: false, // Flag to control the visibility of the filter tray
            showSearch: false,
            resetButtonTitle: 'Reset Filters', // Title for the reset button
            searchTerm: '',
            searchResults: [],
            gridView: false,
            filtersActive: false,
            appliedFilters: {}, // To store the applied filters
        };
    },
    
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        },
        this.getJewelriesOrderes();
        this.showRoute = this.$route.name;
        setTimeout(
            _ => this.delayForm = true, // render form
            2000 // after 2 second
            )
      },    
      
    methods: {
        getJewelriesOrderes(address) {
            this.$axios.get(address ? address : "/api/jewelriesall" ).then(response => {
            this.jewelries = response.data.data;
            this.jewelries = this.shuffleArray(this.jewelries); // Shuffle the jewellery array
            this.updateDynamicFilters();
            this.filteredJewelries = this.jewelries;
            this.$emit("route-data-ready"); // tells App.vue to hide loader
            }).catch(error => {
                console.error("Error fetching jewelries:", error);
            });
        },
        updateJewelries(results) {
            this.searchResults = results;
        },
        // updateDynamicFilters() {
        //     this.dynamicFilters = {
        //         locations: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryLocation))],
        //         types: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryType))],
        //         metals: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryMetal))],
        //         stones: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryStone))],
        //     };
        // },

        updateDynamicFilters() {
            this.dynamicFilters = {
                locations: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryLocation))],
                types: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryType))],
                metals: [...new Set(this.jewelries.map(jewellery => jewellery.JewelleryMetal))],
                stones: [
                    ...new Set(
                        this.jewelries
                            .map(jewellery => jewellery.JewelleryStone) // Get stone string
                            .filter(stone => stone) // Remove empty values
                            .flatMap(stone => stone.split(/\s+/)) // Split by spaces
                    ),
                ],
            };
        },

      
        // handleFilterChange(selectedFilters) {
        //     this.appliedFilters = selectedFilters;
        //     const locations = selectedFilters.locations || [];
        //     const types = selectedFilters.types || [];
        //     const metals = selectedFilters.metals || [];
        //     const stones = selectedFilters.stones || [];

        //     this.filteredJewelries = this.jewelries.filter(jewellery => {
        //         const locationMatch = locations.length ? locations.includes(jewellery.JewelleryLocation) : true;
        //         const typeMatch = types.length ? types.includes(jewellery.JewelleryType) : true;
        //         const metalMatch = metals.length ? metals.includes(jewellery.JewelleryMetal) : true;
        //         const stoneMatch = stones.length ? stones.includes(jewellery.JewelleryStone) : true;
        //         return locationMatch && typeMatch && metalMatch && stoneMatch; 
        //     });
        // },
        handleFilterChange(selectedFilters) {
            this.appliedFilters = selectedFilters;
            const locations = selectedFilters.locations || [];
            const types = selectedFilters.types || [];
            const metals = selectedFilters.metals || [];
            const stones = selectedFilters.stones || [];

            this.filteredJewelries = this.jewelries.filter(jewellery => {
                const locationMatch = locations.length ? locations.includes(jewellery.JewelleryLocation) : true;
                const typeMatch = types.length ? types.includes(jewellery.JewelleryType) : true;
                const metalMatch = metals.length ? metals.includes(jewellery.JewelleryMetal) : true;

                // Updated Stone Match: Checks if any selected stone exists in the JewelleryStone field
                const stoneMatch = stones.length
                    ? stones.some(stone => jewellery.JewelleryStone && jewellery.JewelleryStone.includes(stone))
                    : true;

                return locationMatch && typeMatch && metalMatch && stoneMatch; 
            });
        },


        handleFiltersActive(isActive) {
            this.filtersActive = isActive;
        },
        passResetFilters() {
            if (this.$refs.filtersComponent) {
                this.$refs.filtersComponent.resetFilters();
            } else {
                console.error("filtersComponent is undefined.");
            }
        },
        handleSearchResults(searchResults) {
            this.searchedJewelries = searchResults; 
        },
        toggleFilters() {
            if (this.showSearch) {
                this.showSearch = false;
            }
            this.showFilters = !this.showFilters;
        },
        toggleSearch() {
            if (this.showFilters) {
                this.showFilters = false;
            }
            this.showSearch = !this.showSearch;
        },
        toggleView() {
            this.gridView = !this.gridView;
        },

        loadAlternativeGridImage(jewellery) {
            const img = document.querySelector('.jewellery-image[src*="custom_grid_image_NJ-' + jewellery.SKU + '"]');
            img.src = '/jewelries/gallery/NJ-' + jewellery.SKU + '/grid-image/main_grid_image_NJ-' + jewellery.SKU + '.jpg';
        },
        getImageGridSource(jewellery) {
            return '/jewelries/gallery/NJ-' + jewellery.SKU + '/grid-image/custom_grid_image_NJ-' + jewellery.SKU + '.jpg';
        },    
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },   
        openPopup(index) {
            this.activePopup = index; // Set the active popup to the clicked item's index
        },
        closePopup() {
            this.activePopup = null; // Close the popup
        }, 
    },
    computed: {      
        displayAppliedFilters() {

        return Object.entries(this.appliedFilters)
            .map(([key, values]) => `${values.join(' ')}`)
            .join(' ');
        },

        allJewelries() {
        return _.chunk(this.filteredJewelries, 6); // Ensure filtering and chunking only on filteredJewelries
    } , 
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);

    },
};
</script>
